var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _ellipse, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFgLight2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 152.69 144.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_3",
    "data-name": "Ebene 3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "104.2 0.29 152.19 27.99 152.19 83.4 104.2 111.1 56.22 83.4 56.22 27.99 104.2 0.29",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.32,83.52,104.14,56m.18-.87V.52m0,55.18,47.54,27.59",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.78,50.54a17.37,17.37,0,0,0-34.73,0,16.93,16.93,0,0,0,4.06,11c.06.07.12.15.19.22l.15.16.22.24a22.11,22.11,0,0,1,4.21,6.52,8.94,8.94,0,0,0,.52,1.42.51.51,0,0,0,0,.1h0A8.87,8.87,0,0,0,113,68.69a21.58,21.58,0,0,1,3.54-5.85A17,17,0,0,0,121.78,50.54Z",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.42,75.57a9.34,9.34,0,0,1-8.25-5h0l-.11-.2,0-.14a8.42,8.42,0,0,1-.53-1.44,21.71,21.71,0,0,0-4.11-6.35L91,62.05a2.53,2.53,0,0,1-.22-.26,17.4,17.4,0,0,1-4.15-11.25,17.79,17.79,0,0,1,35.57,0,17.27,17.27,0,0,1-5.42,12.6,21.12,21.12,0,0,0-3.43,5.7A9.25,9.25,0,0,1,104.42,75.57ZM96.8,70l0,.06a8.45,8.45,0,0,0,15.72-1.44,22,22,0,0,1,3.61-6,16.46,16.46,0,0,0,5.2-12,16.95,16.95,0,0,0-33.89,0,16.55,16.55,0,0,0,4,10.73l.17.21.37.4a22.36,22.36,0,0,1,4.29,6.64,8.5,8.5,0,0,0,.51,1.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.42,82.14c-2.17,0-3.93,1.38-3.93,3.07s1.76,3.07,3.93,3.07,3.92-1.37,3.92-3.07S106.58,82.14,104.42,82.14Zm-3.08,3.07c0-1.23,1.38-2.23,3.08-2.23a4,4,0,0,1,1.47.28,2.93,2.93,0,0,0-2.69,2.58,2,2,0,0,0,.93,1.59C102.57,87.32,101.34,86.38,101.34,85.21Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.73,82.36c0,2-2.83,3.6-6.31,3.6s-6.32-1.61-6.32-3.6,2.83-3.61,6.32-3.61S110.73,80.37,110.73,82.36Z",
    style: {
      fill: "#fff"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.42,86.38c-3.78,0-6.74-1.77-6.74-4s3-4,6.74-4,6.73,1.76,6.73,4S108.19,86.38,104.42,86.38Zm0-7.21c-3.2,0-5.89,1.46-5.89,3.19s2.69,3.18,5.89,3.18,5.89-1.46,5.89-3.18S107.61,79.17,104.42,79.17Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.73,80c0,2-2.83,3.6-6.31,3.6S98.1,82,98.1,80s2.83-3.6,6.32-3.6S110.73,78,110.73,80Z",
    style: {
      fill: "#fff"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.42,84c-3.78,0-6.74-1.77-6.74-4s3-4,6.74-4,6.73,1.77,6.73,4S108.19,84,104.42,84Zm0-7.21c-3.2,0-5.89,1.46-5.89,3.19s2.69,3.18,5.89,3.18,5.89-1.45,5.89-3.18S107.61,76.81,104.42,76.81Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.73,77.51c0,2-2.83,3.6-6.31,3.6s-6.32-1.61-6.32-3.6,2.83-3.6,6.32-3.6S110.73,75.52,110.73,77.51Z",
    style: {
      fill: "#fff"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.42,81.53c-3.78,0-6.74-1.77-6.74-4s3-4,6.74-4,6.73,1.77,6.73,4S108.19,81.53,104.42,81.53Zm0-7.21c-3.2,0-5.89,1.46-5.89,3.19s2.69,3.19,5.89,3.19,5.89-1.46,5.89-3.19S107.61,74.32,104.42,74.32Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.73,75.15c0,2-2.83,3.6-6.31,3.6s-6.32-1.61-6.32-3.6,2.83-3.6,6.32-3.6S110.73,73.16,110.73,75.15Z",
    style: {
      fill: "#fff"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104.42,79.17c-3.78,0-6.74-1.76-6.74-4s3-4,6.74-4,6.73,1.77,6.73,4S108.19,79.17,104.42,79.17Zm0-7.2c-3.2,0-5.89,1.46-5.89,3.18s2.69,3.19,5.89,3.19,5.89-1.46,5.89-3.19S107.61,72,104.42,72Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.73,72.66c0,2-2.83,3.61-6.31,3.61s-6.32-1.62-6.32-3.61,2.83-3.6,6.32-3.6S110.73,70.67,110.73,72.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.4,71.83c-3.25,0-5.87,1.5-5.87,3.35a1.26,1.26,0,0,0,0,.28c.94,1.31,3.2,2.24,5.84,2.24s4.81-.89,5.78-2.16a2.25,2.25,0,0,0,.06-.36C110.26,73.33,107.64,71.83,104.4,71.83Z",
    style: {
      fill: "#fff"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.13,68.78a1.26,1.26,0,0,1,0,.27l0,.34a.84.84,0,0,1-.11.21c2.45.39,4.3,1.63,4.3,3.06,0,1.73-2.7,3.19-5.89,3.19s-5.89-1.46-5.89-3.19c0-1.41,1.79-2.64,4.19-3a2,2,0,0,1-.11-.26l0-.34a.53.53,0,0,1,0-.22c-2.86.46-4.91,2-4.91,3.86,0,2.26,3,4,6.74,4s6.73-1.76,6.73-4C111.15,70.77,109.05,69.22,106.13,68.78Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.32,73.55a2.07,2.07,0,0,1-2.19-1.92V62a2.2,2.2,0,0,1,4.37,0v9.66A2.07,2.07,0,0,1,104.32,73.55Zm0-12.71A1.28,1.28,0,0,0,102.94,62v9.66a1.41,1.41,0,0,0,2.76,0V62A1.28,1.28,0,0,0,104.32,60.84Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M105.72,61.56l-1.55-1-1.38.89-.23-.35c-5.45-8.23-5.18-10.36-4.07-11.45.82-.8,1.84-.33,2.67,0a7.93,7.93,0,0,0,3.24.86,8.21,8.21,0,0,0,3.39-.79c.84-.35,1.79-.76,2.6-.07,1,.88,1.42,2.35-4.44,11.48ZM105,60.12l.48.29c5-7.86,5-9.5,4.38-10-.39-.33-.91-.14-1.72.21a8.77,8.77,0,0,1-3.74.85,8.64,8.64,0,0,1-3.57-.93c-.92-.41-1.36-.56-1.72-.2-.7.67-1,2.46,4,10l.47-.3c-3.16-4.81-4.61-8-4.19-9.09l.14-.37.38.12a6.64,6.64,0,0,1,.7.29,9.37,9.37,0,0,0,3.84,1,9.25,9.25,0,0,0,4-.9l.68-.26.59-.19,0,.61C109.51,52.42,107.88,55.57,105,60.12Zm-4.87-8.42c.13.83.85,2.94,4.16,8,2.93-4.59,3.94-6.77,4.29-7.78a9.36,9.36,0,0,1-8.34-.14Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M107.83,93.26c.3.17.3.45,0,.63a1.23,1.23,0,0,1-1.09,0c-.3-.18-.3-.46,0-.63A1.17,1.17,0,0,1,107.83,93.26Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M110.68,91.61a.33.33,0,0,1,0,.63,1.23,1.23,0,0,1-1.09,0,.33.33,0,0,1,0-.63A1.23,1.23,0,0,1,110.68,91.61Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M113.53,90c.3.18.3.46,0,.63a1.17,1.17,0,0,1-1.09,0c-.3-.17-.3-.45,0-.63A1.23,1.23,0,0,1,113.53,90Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M102.13,93.26c.3.17.3.45,0,.63a1.23,1.23,0,0,1-1.09,0c-.3-.18-.3-.46,0-.63A1.17,1.17,0,0,1,102.13,93.26Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M105,91.61a.33.33,0,0,1,0,.63,1.23,1.23,0,0,1-1.09,0,.33.33,0,0,1,0-.63A1.23,1.23,0,0,1,105,91.61Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M107.83,90c.3.18.3.46,0,.63a1.17,1.17,0,0,1-1.09,0c-.3-.17-.3-.45,0-.63A1.23,1.23,0,0,1,107.83,90Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M110.68,88.32c.3.17.3.45,0,.63a1.23,1.23,0,0,1-1.09,0c-.3-.18-.3-.46,0-.63A1.23,1.23,0,0,1,110.68,88.32Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M113.53,86.67c.3.18.3.46,0,.63a1.17,1.17,0,0,1-1.09,0c-.3-.17-.3-.45,0-.63A1.23,1.23,0,0,1,113.53,86.67Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.73,
    cy: 91.92,
    rx: 0.77,
    ry: 0.44
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M102.13,90c.3.18.3.46,0,.63a1.17,1.17,0,0,1-1.09,0c-.3-.17-.3-.45,0-.63A1.23,1.23,0,0,1,102.13,90Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M96.43,90c.3.18.3.46,0,.63a1.17,1.17,0,0,1-1.09,0c-.3-.17-.3-.45,0-.63A1.23,1.23,0,0,1,96.43,90Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M99.28,88.32c.3.17.3.45,0,.63a1.23,1.23,0,0,1-1.09,0c-.3-.18-.3-.46,0-.63A1.23,1.23,0,0,1,99.28,88.32Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4,86.66c.3.17.3.45,0,.63a1.23,1.23,0,0,1-1.09,0c-.3-.18-.3-.46,0-.63A1.17,1.17,0,0,1,96.4,86.66Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M104.2.29,56.22,28l48,27.71,48-27.71Zm48,27.7-48,27.71v55.4l48-27.7Zm-48,27.71L56.22,28V83.4l48,27.7Z",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Products"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "48.48 33.01 96.46 60.71 96.47 116.12 48.48 143.82 0.5 116.12 0.5 60.71 48.48 33.01",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.6,116.24,48.42,88.67m.18-.87V33.24m0,55.18L96.17,116",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "_5",
    "data-name": 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.48,118.66a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0c-.15-.08-.15-.22,0-.3A.57.57,0,0,1,25.48,118.66Z",
    style: {
      fill: "#fff"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25.22,118.6a.51.51,0,0,0-.25.06c-.15.08-.15.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.56,
    cy: 118.04,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.56,117.83a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.9,
    cy: 117.26,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9,117.06a.58.58,0,0,0-.26.06.15.15,0,0,0,0,.29.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.5,116.34c.14.09.14.22,0,.3a.59.59,0,0,1-.52,0c-.14-.08-.14-.21,0-.3A.59.59,0,0,1,29.5,116.34Z",
    style: {
      fill: "#fff"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M29.24,116.28a.55.55,0,0,0-.26.06c-.14.09-.14.22,0,.3a.59.59,0,0,0,.52,0c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.83,115.57c.15.08.15.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,30.83,115.57Z",
    style: {
      fill: "#fff"
    }
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M30.58,115.51a.55.55,0,0,0-.26.06c-.14.08-.14.21,0,.3a.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.09.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.14,117.89c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,24.14,117.89Z",
    style: {
      fill: "#fff"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M23.88,117.83a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.48,117.12a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.52.52,0,0,1,25.48,117.12Z",
    style: {
      fill: "#fff"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M25.22,117.06a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.56,
    cy: 116.49,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M26.56,116.28a.51.51,0,0,0-.25.06c-.15.09-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.16,115.57c.14.08.14.21,0,.3a.59.59,0,0,1-.52,0c-.14-.09-.14-.22,0-.3A.59.59,0,0,1,28.16,115.57Z",
    style: {
      fill: "#fff"
    }
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9,115.51a.58.58,0,0,0-.26.06c-.14.08-.14.21,0,.3a.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.5,114.8a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.59.59,0,0,1,29.5,114.8Z",
    style: {
      fill: "#fff"
    }
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M29.24,114.74a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.59.59,0,0,0,.52,0,.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.8,117.12a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,22.8,117.12Z",
    style: {
      fill: "#fff"
    }
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M22.54,117.06a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.14,116.34c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,24.14,116.34Z",
    style: {
      fill: "#fff"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M23.88,116.28a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.48,115.57c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.15-.09-.15-.22,0-.3A.57.57,0,0,1,25.48,115.57Z",
    style: {
      fill: "#fff"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M25.22,115.51a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.82,114.8a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.57.57,0,0,1,26.82,114.8Z",
    style: {
      fill: "#fff"
    }
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M26.56,114.74a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.16,114c.14.09.14.22,0,.3a.59.59,0,0,1-.52,0c-.14-.08-.14-.21,0-.3A.59.59,0,0,1,28.16,114Z",
    style: {
      fill: "#fff"
    }
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9,114a.58.58,0,0,0-.26.06c-.14.09-.14.22,0,.3a.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.46,116.34c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,21.46,116.34Z",
    style: {
      fill: "#fff"
    }
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M21.21,116.28a.53.53,0,0,0-.26.06c-.14.09-.14.22,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.08.14-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.8,115.57c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,22.8,115.57Z",
    style: {
      fill: "#fff"
    }
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M22.54,115.51a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.14,114.8a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,24.14,114.8Z",
    style: {
      fill: "#fff"
    }
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M23.88,114.74a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.48,114c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.3A.57.57,0,0,1,25.48,114Z",
    style: {
      fill: "#fff"
    }
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M25.22,114A.51.51,0,0,0,25,114c-.15.09-.15.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.12,115.57c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,20.12,115.57Z",
    style: {
      fill: "#fff"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M19.87,115.51a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.09.14-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.46,114.8a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,21.46,114.8Z",
    style: {
      fill: "#fff"
    }
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M21.21,114.74a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.8,114c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,22.8,114Z",
    style: {
      fill: "#fff"
    }
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M22.54,114a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.14,113.25a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,24.14,113.25Z",
    style: {
      fill: "#fff"
    }
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M23.88,113.19a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.11,114a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,20.11,114Z",
    style: {
      fill: "#fff"
    }
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M19.85,114a.52.52,0,0,0-.25.07.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.45,113.24a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,21.45,113.24Z",
    style: {
      fill: "#fff"
    }
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M21.19,113.18a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "22.67 112.67 22.76 112.51 22.95 112.28 22.67 112.69 22.67 112.67",
    style: {
      fill: "#fff"
    }
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M22.53,112.41a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3h0a.55.55,0,0,0-.26-.06Zm.22,0Zm0,0Zm0,0Zm0,0,0,0h0l0,0Zm0,0h0l0,0,0,0Zm0,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.11,112.47c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,20.11,112.47Z",
    style: {
      fill: "#fff"
    }
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M19.85,112.41a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.45,112a.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29C21.08,111.61,21.59,111.91,21.45,112Z",
    style: {
      fill: "#fff"
    }
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M21,111.68l-.06,0a.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.12-.07-.26-.31-.45-.31Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.28,131.79a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,48.28,131.79Z",
    style: {
      fill: "#fff"
    }
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M48,131.72a.43.43,0,0,0-.25.07.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.44.44,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.62,131a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,49.62,131Z",
    style: {
      fill: "#fff"
    }
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M49.36,131a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51,130.24a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,51,130.24Z",
    style: {
      fill: "#fff"
    }
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7,130.18a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.43.43,0,0,0,.25.07.44.44,0,0,0,.26-.07.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.04,
    cy: 129.61,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M52,129.4a.52.52,0,0,0-.25.07c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.56.56,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.64,128.69a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0c-.15-.08-.15-.22,0-.3A.57.57,0,0,1,53.64,128.69Z",
    style: {
      fill: "#fff"
    }
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M53.38,128.63a.51.51,0,0,0-.25.06c-.15.08-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55,127.92c.14.08.14.21,0,.3a.59.59,0,0,1-.52,0c-.14-.09-.14-.22,0-.3A.59.59,0,0,1,55,127.92Z",
    style: {
      fill: "#fff"
    }
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M54.72,127.86a.55.55,0,0,0-.26.06c-.14.08-.14.21,0,.3a.59.59,0,0,0,.52,0c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.94,131a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,46.94,131Z",
    style: {
      fill: "#fff"
    }
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M46.69,131a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.28,130.24a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,48.28,130.24Z",
    style: {
      fill: "#fff"
    }
  }), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M48,130.18a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.43.43,0,0,0,.25.07.44.44,0,0,0,.26-.07.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.62,129.47a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,49.62,129.47Z",
    style: {
      fill: "#fff"
    }
  }), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M49.36,129.4a.52.52,0,0,0-.25.07.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.7,
    cy: 128.84,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7,128.63a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06A.53.53,0,0,0,51,129a.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.3,127.92c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.15-.09-.15-.22,0-.3A.57.57,0,0,1,52.3,127.92Z",
    style: {
      fill: "#fff"
    }
  }), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M52,127.86a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.64,127.15a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.57.57,0,0,1,53.64,127.15Z",
    style: {
      fill: "#fff"
    }
  }), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M53.38,127.09a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.6,130.24a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,45.6,130.24Z",
    style: {
      fill: "#fff"
    }
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M45.35,130.18a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.44.44,0,0,0,.26.07.43.43,0,0,0,.25-.07.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.94,129.47a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,46.94,129.47Z",
    style: {
      fill: "#fff"
    }
  }), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M46.69,129.4a.53.53,0,0,0-.26.07.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.52.52,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.28,128.69a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,48.28,128.69Z",
    style: {
      fill: "#fff"
    }
  }), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M48,128.63a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.62,127.92c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,49.62,127.92Z",
    style: {
      fill: "#fff"
    }
  }), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M49.36,127.86a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51,127.15a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,51,127.15Z",
    style: {
      fill: "#fff"
    }
  }), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7,127.09a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.3,126.37c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.3A.57.57,0,0,1,52.3,126.37Z",
    style: {
      fill: "#fff"
    }
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M52,126.31a.51.51,0,0,0-.25.06c-.15.09-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.26,129.47a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,44.26,129.47Z",
    style: {
      fill: "#fff"
    }
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M44,129.4a.53.53,0,0,0-.26.07.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.52.52,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.6,128.69a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,45.6,128.69Z",
    style: {
      fill: "#fff"
    }
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M45.35,128.63a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.94,127.92c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,46.94,127.92Z",
    style: {
      fill: "#fff"
    }
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M46.69,127.86a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.09.14-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.28,127.15a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,48.28,127.15Z",
    style: {
      fill: "#fff"
    }
  }), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M48,127.09a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.62,126.37c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,49.62,126.37Z",
    style: {
      fill: "#fff"
    }
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M49.36,126.31a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51,125.6c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,51,125.6Z",
    style: {
      fill: "#fff"
    }
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7,125.54a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.92,128.69c.15.08.15.22,0,.3a.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,42.92,128.69Z",
    style: {
      fill: "#fff"
    }
  }), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M42.67,128.63a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.26,127.92c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,44.26,127.92Z",
    style: {
      fill: "#fff"
    }
  }), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M44,127.86a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.09.14-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.6,127.15a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,45.6,127.15Z",
    style: {
      fill: "#fff"
    }
  }), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M45.35,127.09a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.94,126.37c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,46.94,126.37Z",
    style: {
      fill: "#fff"
    }
  }), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M46.69,126.31a.53.53,0,0,0-.26.06c-.14.09-.14.22,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.08.14-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.28,125.6c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,48.28,125.6Z",
    style: {
      fill: "#fff"
    }
  }), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M48,125.54a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3A.51.51,0,0,0,48,126a.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.62,124.83a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,49.62,124.83Z",
    style: {
      fill: "#fff"
    }
  }), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M49.36,124.77a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.32,
    cy: 128.06,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M41.32,127.85a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.91,127.14a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,42.91,127.14Z",
    style: {
      fill: "#fff"
    }
  }), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M42.66,127.08a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.44.44,0,0,0,.26.07.43.43,0,0,0,.25-.07.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.25,126.37a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,44.25,126.37Z",
    style: {
      fill: "#fff"
    }
  }), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M44,126.3a.44.44,0,0,0-.26.07.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.43.43,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.59,125.59a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,45.59,125.59Z",
    style: {
      fill: "#fff"
    }
  }), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M45.33,125.53a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.93,124.82a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,46.93,124.82Z",
    style: {
      fill: "#fff"
    }
  }), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M46.67,124.76a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.43.43,0,0,0,.25.07.44.44,0,0,0,.26-.07.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.27,124.05a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,48.27,124.05Z",
    style: {
      fill: "#fff"
    }
  }), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M48,124a.52.52,0,0,0-.25.07.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29A.53.53,0,0,0,48,124Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.23,127.14c.15.08.15.21,0,.29a.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,40.23,127.14Z",
    style: {
      fill: "#fff"
    }
  }), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M40,127.08a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.46.46,0,0,0,.26.07.43.43,0,0,0,.25-.07c.15-.08.15-.21,0-.29a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.57,126.37c.15.08.15.21,0,.29a.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,41.57,126.37Z",
    style: {
      fill: "#fff"
    }
  }), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M41.32,126.3a.44.44,0,0,0-.26.07.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.29a.43.43,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.91,125.59a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,42.91,125.59Z",
    style: {
      fill: "#fff"
    }
  }), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M42.66,125.53a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.25,124.82a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,44.25,124.82Z",
    style: {
      fill: "#fff"
    }
  }), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M44,124.76a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.44.44,0,0,0,.26.07.43.43,0,0,0,.25-.07.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.59,124.05a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,45.59,124.05Z",
    style: {
      fill: "#fff"
    }
  }), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M45.33,124a.52.52,0,0,0-.25.07.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.93,123.27a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,46.93,123.27Z",
    style: {
      fill: "#fff"
    }
  }), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M46.67,123.21a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.9,126.37a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.53.53,0,0,1,38.9,126.37Z",
    style: {
      fill: "#fff"
    }
  }), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M38.64,126.3a.46.46,0,0,0-.26.07.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06.15.15,0,0,0,0-.29.48.48,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.23,125.59c.15.08.15.22,0,.3a.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,40.23,125.59Z",
    style: {
      fill: "#fff"
    }
  }), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M40,125.53a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3A.55.55,0,0,0,40,126a.51.51,0,0,0,.25-.06c.15-.08.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.32,
    cy: 124.97,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M41.32,124.76a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.44.44,0,0,0,.26.07.43.43,0,0,0,.25-.07c.15-.08.15-.21,0-.29a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.91,124.05a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,42.91,124.05Z",
    style: {
      fill: "#fff"
    }
  }), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M42.66,124a.53.53,0,0,0-.26.07.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.52.52,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.25,123.27a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,44.25,123.27Z",
    style: {
      fill: "#fff"
    }
  }), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M44,123.21a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.59,122.5c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,45.59,122.5Z",
    style: {
      fill: "#fff"
    }
  }), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M45.33,122.44a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.56,125.59a.16.16,0,0,1,0,.3.59.59,0,0,1-.52,0,.16.16,0,0,1,0-.3A.59.59,0,0,1,37.56,125.59Z",
    style: {
      fill: "#fff"
    }
  }), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3,125.53a.58.58,0,0,0-.26.06.16.16,0,0,0,0,.3.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.9,124.82a.15.15,0,0,1,0,.29.53.53,0,0,1-.52,0,.15.15,0,0,1,0-.29A.59.59,0,0,1,38.9,124.82Z",
    style: {
      fill: "#fff"
    }
  }), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M38.64,124.76a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.46.46,0,0,0,.26.07.48.48,0,0,0,.26-.07.15.15,0,0,0,0-.29.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.23,124.05c.15.08.15.21,0,.29a.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,40.23,124.05Z",
    style: {
      fill: "#fff"
    }
  }), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M40,124a.56.56,0,0,0-.26.07.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.29A.52.52,0,0,0,40,124Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.32,
    cy: 123.42,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M41.32,123.21a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.22,124.82a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.57.57,0,0,1,36.22,124.82Z",
    style: {
      fill: "#fff"
    }
  }), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M36,124.76a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.43.43,0,0,0,.25.07.46.46,0,0,0,.26-.07.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.91,122.5c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,42.91,122.5Z",
    style: {
      fill: "#fff"
    }
  }), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M42.66,122.44a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.09.14-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.25,121.73a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,44.25,121.73Z",
    style: {
      fill: "#fff"
    }
  }), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M44,121.67a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.3,
    cy: 124.19,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3,124a.59.59,0,0,0-.26.07.15.15,0,0,0,0,.29.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.56.56,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.9,123.27a.16.16,0,0,1,0,.3.59.59,0,0,1-.52,0,.16.16,0,0,1,0-.3A.59.59,0,0,1,38.9,123.27Z",
    style: {
      fill: "#fff"
    }
  }), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M38.64,123.21a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06.16.16,0,0,0,0-.3.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.23,122.5c.15.08.15.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,40.23,122.5Z",
    style: {
      fill: "#fff"
    }
  }), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M40,122.44a.55.55,0,0,0-.26.06c-.14.08-.14.21,0,.3a.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.09.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.88,124.05a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.52.52,0,0,1,34.88,124.05Z",
    style: {
      fill: "#fff"
    }
  }), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M34.62,124a.52.52,0,0,0-.25.07c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.56.56,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.22,123.27a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0c-.15-.08-.15-.22,0-.3A.57.57,0,0,1,36.22,123.27Z",
    style: {
      fill: "#fff"
    }
  }), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M36,123.21a.51.51,0,0,0-.25.06c-.15.08-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.57,121.73c.15.08.15.21,0,.29a.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,41.57,121.73Z",
    style: {
      fill: "#fff"
    }
  }), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M41.32,121.67a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.29a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.91,121c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,42.91,121Z",
    style: {
      fill: "#fff"
    }
  }), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M42.66,120.89a.53.53,0,0,0-.26.06c-.14.09-.14.22,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.08.14-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.56,122.5c.14.08.14.21,0,.3a.59.59,0,0,1-.52,0c-.14-.09-.14-.22,0-.3A.59.59,0,0,1,37.56,122.5Z",
    style: {
      fill: "#fff"
    }
  }), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3,122.44a.58.58,0,0,0-.26.06c-.14.08-.14.21,0,.3a.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.9,121.73a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.59.59,0,0,1,38.9,121.73Z",
    style: {
      fill: "#fff"
    }
  }), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M38.64,121.67a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06.15.15,0,0,0,0-.29.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.28,
    cy: 123.42,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M33.28,123.21a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.88,122.5c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.15-.09-.15-.22,0-.3A.57.57,0,0,1,34.88,122.5Z",
    style: {
      fill: "#fff"
    }
  }), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M34.62,122.44a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.22,121.73a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.57.57,0,0,1,36.22,121.73Z",
    style: {
      fill: "#fff"
    }
  }), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M36,121.67a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.98,
    cy: 121.1,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M40,120.89a.55.55,0,0,0-.26.06c-.14.09-.14.22,0,.3a.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.32,
    cy: 120.33,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M41.32,120.12a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.09.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.56,121c.14.09.14.22,0,.3a.59.59,0,0,1-.52,0c-.14-.08-.14-.21,0-.3A.59.59,0,0,1,37.56,121Z",
    style: {
      fill: "#fff"
    }
  }), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3,120.89A.58.58,0,0,0,37,121c-.14.09-.14.22,0,.3a.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.2,122.5c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,32.2,122.5Z",
    style: {
      fill: "#fff"
    }
  }), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M31.94,122.44a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.54,121.73a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,33.54,121.73Z",
    style: {
      fill: "#fff"
    }
  }), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M33.28,121.67a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.62,
    cy: 121.1,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M34.62,120.89a.51.51,0,0,0-.25.06c-.15.09-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.22,120.18c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.15-.09-.15-.22,0-.3A.57.57,0,0,1,36.22,120.18Z",
    style: {
      fill: "#fff"
    }
  }), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M36,120.12a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.9,120.18c.14.08.14.21,0,.3a.59.59,0,0,1-.52,0c-.14-.09-.14-.22,0-.3A.59.59,0,0,1,38.9,120.18Z",
    style: {
      fill: "#fff"
    }
  }), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M38.64,120.12a.55.55,0,0,0-.26.06c-.14.08-.14.21,0,.3a.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.23,119.41c.15.08.15.21,0,.29a.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,40.23,119.41Z",
    style: {
      fill: "#fff"
    }
  }), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M40,119.35a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.29a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.85,121.72a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,30.85,121.72Z",
    style: {
      fill: "#fff"
    }
  }), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M30.59,121.66a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.43.43,0,0,0,.25.07.44.44,0,0,0,.26-.07.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.19,121a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.52.52,0,0,1,32.19,121Z",
    style: {
      fill: "#fff"
    }
  }), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M31.93,120.88a.43.43,0,0,0-.25.07c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.44.44,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.53,120.17a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0c-.15-.08-.15-.22,0-.3A.57.57,0,0,1,33.53,120.17Z",
    style: {
      fill: "#fff"
    }
  }), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M33.27,120.11a.51.51,0,0,0-.25.06c-.15.08-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.87,119.4a.15.15,0,0,1,0,.29.53.53,0,0,1-.52,0,.15.15,0,0,1,0-.29A.59.59,0,0,1,34.87,119.4Z",
    style: {
      fill: "#fff"
    }
  }), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M34.61,119.34a.58.58,0,0,0-.26.06.15.15,0,0,0,0,.29.48.48,0,0,0,.26.07.46.46,0,0,0,.26-.07.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.21,118.63a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.53.53,0,0,1,36.21,118.63Z",
    style: {
      fill: "#fff"
    }
  }), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M36,118.56a.56.56,0,0,0-.26.07.15.15,0,0,0,0,.29.59.59,0,0,0,.52,0,.15.15,0,0,0,0-.29.56.56,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.56,119.41a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.59.59,0,0,1,37.56,119.41Z",
    style: {
      fill: "#fff"
    }
  }), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3,119.35a.58.58,0,0,0-.26.06.15.15,0,0,0,0,.29.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.51,121a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,29.51,121Z",
    style: {
      fill: "#fff"
    }
  }), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25,120.88A.43.43,0,0,0,29,121a.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.44.44,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.85,120.17a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,30.85,120.17Z",
    style: {
      fill: "#fff"
    }
  }), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M30.59,120.11a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.19,119.4a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.57.57,0,0,1,32.19,119.4Z",
    style: {
      fill: "#fff"
    }
  }), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M31.93,119.34a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.43.43,0,0,0,.25.07.44.44,0,0,0,.26-.07.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.53,118.63a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.52.52,0,0,1,33.53,118.63Z",
    style: {
      fill: "#fff"
    }
  }), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M33.27,118.56a.52.52,0,0,0-.25.07c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.56.56,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.87,117.85a.16.16,0,0,1,0,.3.59.59,0,0,1-.52,0,.16.16,0,0,1,0-.3A.59.59,0,0,1,34.87,117.85Z",
    style: {
      fill: "#fff"
    }
  }), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M34.61,117.79a.58.58,0,0,0-.26.06.16.16,0,0,0,0,.3.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.95,
    cy: 117.23,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M36,117a.55.55,0,0,0-.26.06c-.14.08-.14.21,0,.3a.59.59,0,0,0,.52,0c.14-.09.14-.22,0-.3A.55.55,0,0,0,36,117Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.17,120.17a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,28.17,120.17Z",
    style: {
      fill: "#fff"
    }
  }), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M27.92,120.11a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.51,119.4a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,29.51,119.4Z",
    style: {
      fill: "#fff"
    }
  }), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25,119.34a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.43.43,0,0,0,.25.07.44.44,0,0,0,.26-.07.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.59,
    cy: 118.77,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M30.59,118.56a.52.52,0,0,0-.25.07.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.19,117.85a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0c-.15-.08-.15-.22,0-.3A.57.57,0,0,1,32.19,117.85Z",
    style: {
      fill: "#fff"
    }
  }), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M31.93,117.79a.51.51,0,0,0-.25.06c-.15.08-.15.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.53,117.08c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.15-.09-.15-.22,0-.3A.57.57,0,0,1,33.53,117.08Z",
    style: {
      fill: "#fff"
    }
  }), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M33.27,117a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.87,116.31a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.53.53,0,0,1,34.87,116.31Z",
    style: {
      fill: "#fff"
    }
  }), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M34.61,116.25a.58.58,0,0,0-.26.06.15.15,0,0,0,0,.29.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.83,119.4a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,26.83,119.4Z",
    style: {
      fill: "#fff"
    }
  }), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M26.58,119.34a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.44.44,0,0,0,.26.07.43.43,0,0,0,.25-.07.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.17,118.63a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,28.17,118.63Z",
    style: {
      fill: "#fff"
    }
  }), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M27.92,118.56a.53.53,0,0,0-.26.07.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.52.52,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.51,117.85a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,29.51,117.85Z",
    style: {
      fill: "#fff"
    }
  }), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25,117.79a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.85,117.08c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,30.85,117.08Z",
    style: {
      fill: "#fff"
    }
  }), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M30.59,117a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.19,116.31a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.52.52,0,0,1,32.19,116.31Z",
    style: {
      fill: "#fff"
    }
  }), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M31.93,116.25a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.53,115.53c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.3A.57.57,0,0,1,33.53,115.53Z",
    style: {
      fill: "#fff"
    }
  }), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M33.27,115.47a.51.51,0,0,0-.25.06c-.15.09-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.9,118.63c.14.09.14.22,0,.3a.59.59,0,0,1-.52,0c-.14-.08-.14-.21,0-.3A.59.59,0,0,1,38.9,118.63Z",
    style: {
      fill: "#fff"
    }
  }), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M38.64,118.57a.55.55,0,0,0-.26.06c-.14.09-.14.22,0,.3a.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.54,117.85c.15.08.15.22,0,.3a.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,37.54,117.85Z",
    style: {
      fill: "#fff"
    }
  }), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M37.29,117.79a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.38,134.76a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,56.38,134.76Z",
    style: {
      fill: "#fff"
    }
  }), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M56.12,134.7a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.72,134a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.57.57,0,0,1,57.72,134Z",
    style: {
      fill: "#fff"
    }
  }), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M57.46,133.93a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.43.43,0,0,0,.25.07.44.44,0,0,0,.26-.07.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.06,133.22a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.52.52,0,0,1,59.06,133.22Z",
    style: {
      fill: "#fff"
    }
  }), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8,133.15a.52.52,0,0,0-.25.07c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.56.56,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.14,
    cy: 132.59,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M60.14,132.38a.58.58,0,0,0-.26.06.16.16,0,0,0,0,.3.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.74,131.67c.14.08.14.21,0,.3a.59.59,0,0,1-.52,0c-.14-.09-.14-.22,0-.3A.59.59,0,0,1,61.74,131.67Z",
    style: {
      fill: "#fff"
    }
  }), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M61.48,131.61a.55.55,0,0,0-.26.06c-.14.08-.14.21,0,.3a.59.59,0,0,0,.52,0c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.69,134.75c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,53.69,134.75Z",
    style: {
      fill: "#fff"
    }
  }), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M53.43,134.69a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55,134a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,55,134Z",
    style: {
      fill: "#fff"
    }
  }), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M54.77,133.92a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.37,133.21a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.57.57,0,0,1,56.37,133.21Z",
    style: {
      fill: "#fff"
    }
  }), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M56.11,133.15a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.71,132.43c.14.09.14.22,0,.3a.59.59,0,0,1-.52,0c-.14-.08-.14-.21,0-.3A.59.59,0,0,1,57.71,132.43Z",
    style: {
      fill: "#fff"
    }
  }), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M57.45,132.37a.58.58,0,0,0-.26.06c-.14.09-.14.22,0,.3a.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.05,131.66a.16.16,0,0,1,0,.3.59.59,0,0,1-.52,0,.16.16,0,0,1,0-.3A.59.59,0,0,1,59.05,131.66Z",
    style: {
      fill: "#fff"
    }
  }), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M58.79,131.6a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.59.59,0,0,0,.52,0,.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.39,130.89a.15.15,0,0,1,0,.29.53.53,0,0,1-.52,0,.15.15,0,0,1,0-.29A.59.59,0,0,1,60.39,130.89Z",
    style: {
      fill: "#fff"
    }
  }), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M60.13,130.83a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.46.46,0,0,0,.26.07.48.48,0,0,0,.26-.07.15.15,0,0,0,0-.29.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.35,134a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,52.35,134Z",
    style: {
      fill: "#fff"
    }
  }), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M52.09,133.92a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.69,133.21a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,53.69,133.21Z",
    style: {
      fill: "#fff"
    }
  }), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M53.43,133.15a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55,132.43c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,55,132.43Z",
    style: {
      fill: "#fff"
    }
  }), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M54.77,132.37a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.37,131.66a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0c-.15-.08-.15-.22,0-.3A.57.57,0,0,1,56.37,131.66Z",
    style: {
      fill: "#fff"
    }
  }), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M56.11,131.6a.51.51,0,0,0-.25.06c-.15.08-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.71,130.89a.15.15,0,0,1,0,.29.53.53,0,0,1-.52,0,.15.15,0,0,1,0-.29A.59.59,0,0,1,57.71,130.89Z",
    style: {
      fill: "#fff"
    }
  }), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M57.45,130.83a.58.58,0,0,0-.26.06.15.15,0,0,0,0,.29.48.48,0,0,0,.26.07.46.46,0,0,0,.26-.07.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.05,130.12a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.53.53,0,0,1,59.05,130.12Z",
    style: {
      fill: "#fff"
    }
  }), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M58.79,130.05a.46.46,0,0,0-.26.07.15.15,0,0,0,0,.29.59.59,0,0,0,.52,0,.15.15,0,0,0,0-.29.46.46,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51,133.21a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,51,133.21Z",
    style: {
      fill: "#fff"
    }
  }), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M50.76,133.15a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.35,132.43c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,52.35,132.43Z",
    style: {
      fill: "#fff"
    }
  }), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M52.09,132.37a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.69,131.66a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,53.69,131.66Z",
    style: {
      fill: "#fff"
    }
  }), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M53.43,131.6a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55,130.89a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,55,130.89Z",
    style: {
      fill: "#fff"
    }
  }), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M54.77,130.83a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.43.43,0,0,0,.25.07.44.44,0,0,0,.26-.07.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.37,130.12a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.52.52,0,0,1,56.37,130.12Z",
    style: {
      fill: "#fff"
    }
  }), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M56.11,130.05a.43.43,0,0,0-.25.07c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.46.46,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.71,129.34a.16.16,0,0,1,0,.3.59.59,0,0,1-.52,0,.16.16,0,0,1,0-.3A.59.59,0,0,1,57.71,129.34Z",
    style: {
      fill: "#fff"
    }
  }), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M57.45,129.28a.58.58,0,0,0-.26.06.16.16,0,0,0,0,.3.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.67,132.43c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,49.67,132.43Z",
    style: {
      fill: "#fff"
    }
  }), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M49.42,132.37a.53.53,0,0,0-.26.06c-.14.09-.14.22,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.08.14-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51,131.66a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,51,131.66Z",
    style: {
      fill: "#fff"
    }
  }), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M50.76,131.6a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06A.51.51,0,0,0,51,132a.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.35,130.89a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,52.35,130.89Z",
    style: {
      fill: "#fff"
    }
  }), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M52.09,130.83a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.43.43,0,0,0,.25.07.44.44,0,0,0,.26-.07.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.69,130.12a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,53.69,130.12Z",
    style: {
      fill: "#fff"
    }
  }), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M53.43,130.05a.43.43,0,0,0-.25.07.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.44.44,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55,129.34a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,55,129.34Z",
    style: {
      fill: "#fff"
    }
  }), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M54.77,129.28a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.37,128.57a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.57.57,0,0,1,56.37,128.57Z",
    style: {
      fill: "#fff"
    }
  }), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M56.11,128.51a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.31,127.14c.15.08.15.22,0,.3a.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,56.31,127.14Z",
    style: {
      fill: "#fff"
    }
  }), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M56.06,127.08a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.65,126.37c.15.08.15.21,0,.29a.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,57.65,126.37Z",
    style: {
      fill: "#fff"
    }
  }), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4,126.31a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.44.44,0,0,0,.26.07.43.43,0,0,0,.25-.07c.15-.08.15-.21,0-.29a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59,125.6a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,59,125.6Z",
    style: {
      fill: "#fff"
    }
  }), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M58.74,125.53a.53.53,0,0,0-.26.07.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.52.52,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.33,124.82a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,60.33,124.82Z",
    style: {
      fill: "#fff"
    }
  }), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M60.08,124.76a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.67,124.05c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,61.67,124.05Z",
    style: {
      fill: "#fff"
    }
  }), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M61.41,124a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63,123.28a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,63,123.28Z",
    style: {
      fill: "#fff"
    }
  }), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M62.75,123.22a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.35,122.5c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,64.35,122.5Z",
    style: {
      fill: "#fff"
    }
  }), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M64.09,122.44a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.69,121.73c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.15-.09-.15-.22,0-.3A.57.57,0,0,1,65.69,121.73Z",
    style: {
      fill: "#fff"
    }
  }), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M65.43,121.67a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67,121a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.57.57,0,0,1,67,121Z",
    style: {
      fill: "#fff"
    }
  }), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M66.77,120.9a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.37,120.18c.14.09.14.22,0,.3a.59.59,0,0,1-.52,0c-.14-.08-.14-.21,0-.3A.59.59,0,0,1,68.37,120.18Z",
    style: {
      fill: "#fff"
    }
  }), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M68.11,120.12a.58.58,0,0,0-.26.06c-.14.09-.14.22,0,.3a.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.71,119.41a.16.16,0,0,1,0,.3.59.59,0,0,1-.52,0,.16.16,0,0,1,0-.3A.59.59,0,0,1,69.71,119.41Z",
    style: {
      fill: "#fff"
    }
  }), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M69.45,119.35a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06.16.16,0,0,0,0-.3.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71,118.64c.15.08.15.21,0,.29a.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,71,118.64Z",
    style: {
      fill: "#fff"
    }
  }), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M70.79,118.58a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.29a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55,126.37a.15.15,0,0,1,0,.29.53.53,0,0,1-.52,0,.15.15,0,0,1,0-.29A.59.59,0,0,1,55,126.37Z",
    style: {
      fill: "#fff"
    }
  }), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M54.72,126.31a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.46.46,0,0,0,.26.07.48.48,0,0,0,.26-.07.15.15,0,0,0,0-.29.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.31,125.6c.15.08.15.21,0,.29a.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,56.31,125.6Z",
    style: {
      fill: "#fff"
    }
  }), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M56.06,125.53a.56.56,0,0,0-.26.07.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.29a.52.52,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.65,124.82c.15.08.15.22,0,.3a.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,57.65,124.82Z",
    style: {
      fill: "#fff"
    }
  }), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4,124.76a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59,124.05c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,59,124.05Z",
    style: {
      fill: "#fff"
    }
  }), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M58.74,124a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.09.14-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.33,123.28a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,60.33,123.28Z",
    style: {
      fill: "#fff"
    }
  }), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M60.08,123.22a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.67,122.5c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,61.67,122.5Z",
    style: {
      fill: "#fff"
    }
  }), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M61.41,122.44a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63,121.73c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,63,121.73Z",
    style: {
      fill: "#fff"
    }
  }), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M62.75,121.67a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06A.53.53,0,0,0,63,122c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.35,121a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,64.35,121Z",
    style: {
      fill: "#fff"
    }
  }), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M64.09,120.9a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.69,120.18c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.3A.57.57,0,0,1,65.69,120.18Z",
    style: {
      fill: "#fff"
    }
  }), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M65.43,120.12a.51.51,0,0,0-.25.06c-.15.09-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67,119.41a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0c-.15-.08-.15-.22,0-.3A.57.57,0,0,1,67,119.41Z",
    style: {
      fill: "#fff"
    }
  }), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M66.77,119.35a.51.51,0,0,0-.25.06c-.15.08-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.37,118.64a.15.15,0,0,1,0,.29.53.53,0,0,1-.52,0,.15.15,0,0,1,0-.29A.59.59,0,0,1,68.37,118.64Z",
    style: {
      fill: "#fff"
    }
  }), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M68.11,118.58a.58.58,0,0,0-.26.06.15.15,0,0,0,0,.29.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.71,117.86c.14.09.14.22,0,.3a.59.59,0,0,1-.52,0c-.14-.08-.14-.21,0-.3A.59.59,0,0,1,69.71,117.86Z",
    style: {
      fill: "#fff"
    }
  }), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M69.45,117.8a.55.55,0,0,0-.26.06c-.14.09-.14.22,0,.3a.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.38,
    cy: 125.74,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M53.38,125.53a.56.56,0,0,0-.26.07.15.15,0,0,0,0,.29.59.59,0,0,0,.52,0,.15.15,0,0,0,0-.29.56.56,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55,124.82a.16.16,0,0,1,0,.3.59.59,0,0,1-.52,0,.16.16,0,0,1,0-.3A.59.59,0,0,1,55,124.82Z",
    style: {
      fill: "#fff"
    }
  }), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M54.72,124.76a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06.16.16,0,0,0,0-.3.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.31,124.05c.15.08.15.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,56.31,124.05Z",
    style: {
      fill: "#fff"
    }
  }), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M56.06,124a.55.55,0,0,0-.26.06c-.14.08-.14.21,0,.3a.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.09.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.65,123.28c.15.08.15.21,0,.29a.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,57.65,123.28Z",
    style: {
      fill: "#fff"
    }
  }), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4,123.22a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.29a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59,122.5c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,59,122.5Z",
    style: {
      fill: "#fff"
    }
  }), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M58.74,122.44a.53.53,0,0,0-.26.06c-.14.09-.14.22,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.08.14-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.33,121.73c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,60.33,121.73Z",
    style: {
      fill: "#fff"
    }
  }), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M60.08,121.67a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.09.14-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.67,121a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,61.67,121Z",
    style: {
      fill: "#fff"
    }
  }), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M61.41,120.9a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63,120.18c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,63,120.18Z",
    style: {
      fill: "#fff"
    }
  }), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M62.75,120.12a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.35,119.41a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,64.35,119.41Z",
    style: {
      fill: "#fff"
    }
  }), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M64.09,119.35a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.69,118.64a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.57.57,0,0,1,65.69,118.64Z",
    style: {
      fill: "#fff"
    }
  }), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M65.43,118.58a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67,117.86c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.3A.57.57,0,0,1,67,117.86Z",
    style: {
      fill: "#fff"
    }
  }), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M66.77,117.8a.51.51,0,0,0-.25.06c-.15.09-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.3,124.82a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0c-.15-.08-.15-.22,0-.3A.57.57,0,0,1,52.3,124.82Z",
    style: {
      fill: "#fff"
    }
  }), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M52,124.76a.51.51,0,0,0-.25.06c-.15.08-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.64,124.05c.14.08.14.21,0,.3a.59.59,0,0,1-.52,0c-.14-.09-.14-.22,0-.3A.59.59,0,0,1,53.64,124.05Z",
    style: {
      fill: "#fff"
    }
  }), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M53.38,124a.55.55,0,0,0-.26.06c-.14.08-.14.21,0,.3a.59.59,0,0,0,.52,0c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55,123.28a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.53.53,0,0,1,55,123.28Z",
    style: {
      fill: "#fff"
    }
  }), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M54.72,123.22a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06.15.15,0,0,0,0-.29.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.31,122.5c.15.09.15.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,56.31,122.5Z",
    style: {
      fill: "#fff"
    }
  }), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M56.06,122.44a.55.55,0,0,0-.26.06c-.14.09-.14.22,0,.3a.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.65,121.73c.15.08.15.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,57.65,121.73Z",
    style: {
      fill: "#fff"
    }
  }), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4,121.67a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.09.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.74,
    cy: 121.11,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M58.74,120.9a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.33,120.18c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,60.33,120.18Z",
    style: {
      fill: "#fff"
    }
  }), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M60.08,120.12a.53.53,0,0,0-.26.06c-.14.09-.14.22,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.08.14-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.67,119.41a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,61.67,119.41Z",
    style: {
      fill: "#fff"
    }
  }), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M61.41,119.35a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63,118.64a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,63,118.64Z",
    style: {
      fill: "#fff"
    }
  }), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M62.75,118.58a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.35,117.86c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,64.35,117.86Z",
    style: {
      fill: "#fff"
    }
  }), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M64.09,117.8a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.69,117.09a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0c-.15-.08-.15-.22,0-.3A.57.57,0,0,1,65.69,117.09Z",
    style: {
      fill: "#fff"
    }
  }), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M65.43,117a.51.51,0,0,0-.25.06c-.15.08-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51,124.05c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.15-.09-.15-.22,0-.3A.57.57,0,0,1,51,124.05Z",
    style: {
      fill: "#fff"
    }
  }), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7,124a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.3,123.28a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.52.52,0,0,1,52.3,123.28Z",
    style: {
      fill: "#fff"
    }
  }), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M52,123.22a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.64,122.5c.14.09.14.22,0,.3a.59.59,0,0,1-.52,0c-.14-.08-.14-.21,0-.3A.59.59,0,0,1,53.64,122.5Z",
    style: {
      fill: "#fff"
    }
  }), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M53.38,122.44a.55.55,0,0,0-.26.06c-.14.09-.14.22,0,.3a.59.59,0,0,0,.52,0c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55,121.73c.14.08.14.21,0,.3a.59.59,0,0,1-.52,0c-.14-.09-.14-.22,0-.3A.59.59,0,0,1,55,121.73Z",
    style: {
      fill: "#fff"
    }
  }), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M54.72,121.67a.55.55,0,0,0-.26.06c-.14.08-.14.21,0,.3a.55.55,0,0,0,.26.06A.58.58,0,0,0,55,122c.14-.09.14-.22,0-.3a.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.31,121c.15.08.15.21,0,.29a.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,56.31,121Z",
    style: {
      fill: "#fff"
    }
  }), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M56.06,120.9a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.29a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.65,120.18c.15.09.15.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,57.65,120.18Z",
    style: {
      fill: "#fff"
    }
  }), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4,120.12a.53.53,0,0,0-.26.06c-.14.09-.14.22,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59,119.41a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,59,119.41Z",
    style: {
      fill: "#fff"
    }
  }), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M58.74,119.35a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.33,118.64a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,60.33,118.64Z",
    style: {
      fill: "#fff"
    }
  }), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M60.08,118.58a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.67,117.86c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,61.67,117.86Z",
    style: {
      fill: "#fff"
    }
  }), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M61.41,117.8a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63,117.09a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,63,117.09Z",
    style: {
      fill: "#fff"
    }
  }), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M62.75,117a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.35,116.32a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,64.35,116.32Z",
    style: {
      fill: "#fff"
    }
  }), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M64.09,116.26a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.52.52,0,0,0,.25.07.53.53,0,0,0,.26-.07.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.61,123.27a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.57.57,0,0,1,49.61,123.27Z",
    style: {
      fill: "#fff"
    }
  }), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M49.35,123.21a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.43.43,0,0,0,.25.07.46.46,0,0,0,.26-.07.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51,122.5a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.53.53,0,0,1,51,122.5Z",
    style: {
      fill: "#fff"
    }
  }), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M50.69,122.43a.48.48,0,0,0-.26.07.15.15,0,0,0,0,.29.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.46.46,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.29,121.72a.16.16,0,0,1,0,.3.59.59,0,0,1-.52,0,.16.16,0,0,1,0-.3A.59.59,0,0,1,52.29,121.72Z",
    style: {
      fill: "#fff"
    }
  }), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M52,121.66a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06.16.16,0,0,0,0-.3.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.62,121c.15.08.15.21,0,.29a.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,53.62,121Z",
    style: {
      fill: "#fff"
    }
  }), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M53.37,120.89a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.46.46,0,0,0,.26.07.43.43,0,0,0,.25-.07c.15-.08.15-.21,0-.29a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55,120.18c.15.08.15.21,0,.29a.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,55,120.18Z",
    style: {
      fill: "#fff"
    }
  }), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M54.71,120.11a.56.56,0,0,0-.26.07.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.29a.52.52,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.3,119.4a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,56.3,119.4Z",
    style: {
      fill: "#fff"
    }
  }), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M56.05,119.34a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.64,118.63c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,57.64,118.63Z",
    style: {
      fill: "#fff"
    }
  }), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M57.39,118.57a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.09.14-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59,117.86a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,59,117.86Z",
    style: {
      fill: "#fff"
    }
  }), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M58.73,117.8a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.32,117.08c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,60.32,117.08Z",
    style: {
      fill: "#fff"
    }
  }), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M60.06,117a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.66,116.31c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,61.66,116.31Z",
    style: {
      fill: "#fff"
    }
  }), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4,116.25a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63,115.54a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.57.57,0,0,1,63,115.54Z",
    style: {
      fill: "#fff"
    }
  }), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M62.74,115.48a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.27,122.5a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.52.52,0,0,1,48.27,122.5Z",
    style: {
      fill: "#fff"
    }
  }), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M48,122.43a.43.43,0,0,0-.25.07c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.46.46,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.61,121.72a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0c-.15-.08-.15-.22,0-.3A.57.57,0,0,1,49.61,121.72Z",
    style: {
      fill: "#fff"
    }
  }), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M49.35,121.66a.51.51,0,0,0-.25.06c-.15.08-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51,121a.15.15,0,0,1,0,.29.53.53,0,0,1-.52,0,.15.15,0,0,1,0-.29A.59.59,0,0,1,51,121Z",
    style: {
      fill: "#fff"
    }
  }), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M50.69,120.89a.58.58,0,0,0-.26.06.15.15,0,0,0,0,.29.48.48,0,0,0,.26.07.46.46,0,0,0,.26-.07.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.29,120.18a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.53.53,0,0,1,52.29,120.18Z",
    style: {
      fill: "#fff"
    }
  }), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M52,120.11a.56.56,0,0,0-.26.07.15.15,0,0,0,0,.29.59.59,0,0,0,.52,0,.15.15,0,0,0,0-.29.56.56,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.62,119.4c.15.08.15.22,0,.3a.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,53.62,119.4Z",
    style: {
      fill: "#fff"
    }
  }), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M53.37,119.34a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55,118.63c.15.08.15.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,55,118.63Z",
    style: {
      fill: "#fff"
    }
  }), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M54.71,118.57a.55.55,0,0,0-.26.06c-.14.08-.14.21,0,.3a.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.09.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.3,117.86a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,56.3,117.86Z",
    style: {
      fill: "#fff"
    }
  }), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M56.05,117.8a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.64,117.08c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,57.64,117.08Z",
    style: {
      fill: "#fff"
    }
  }), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M57.39,117a.53.53,0,0,0-.26.06c-.14.09-.14.22,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.08.14-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59,116.31c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,59,116.31Z",
    style: {
      fill: "#fff"
    }
  }), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M58.73,116.25a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.09.14-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.32,115.54a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,60.32,115.54Z",
    style: {
      fill: "#fff"
    }
  }), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M60.06,115.48a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.93,121.72a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,46.93,121.72Z",
    style: {
      fill: "#fff"
    }
  }), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M46.67,121.66a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.27,121a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.57.57,0,0,1,48.27,121Z",
    style: {
      fill: "#fff"
    }
  }), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M48,120.89a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.43.43,0,0,0,.25.07.46.46,0,0,0,.26-.07.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.61,120.18a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.52.52,0,0,1,49.61,120.18Z",
    style: {
      fill: "#fff"
    }
  }), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M49.35,120.11a.52.52,0,0,0-.25.07c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.56.56,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51,119.4a.16.16,0,0,1,0,.3.59.59,0,0,1-.52,0,.16.16,0,0,1,0-.3A.59.59,0,0,1,51,119.4Z",
    style: {
      fill: "#fff"
    }
  }), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M50.69,119.34a.58.58,0,0,0-.26.06.16.16,0,0,0,0,.3.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.29,118.63c.14.08.14.21,0,.3a.59.59,0,0,1-.52,0c-.14-.09-.14-.22,0-.3A.59.59,0,0,1,52.29,118.63Z",
    style: {
      fill: "#fff"
    }
  }), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M52,118.57a.55.55,0,0,0-.26.06c-.14.08-.14.21,0,.3a.59.59,0,0,0,.52,0c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.62,117.86c.15.08.15.21,0,.29a.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,53.62,117.86Z",
    style: {
      fill: "#fff"
    }
  }), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M53.37,117.8a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.29a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55,117.08c.15.09.15.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,55,117.08Z",
    style: {
      fill: "#fff"
    }
  }), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M54.71,117a.55.55,0,0,0-.26.06c-.14.09-.14.22,0,.3a.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.3,116.31c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,56.3,116.31Z",
    style: {
      fill: "#fff"
    }
  }), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M56.05,116.25a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.09.14-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.64,115.54a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,57.64,115.54Z",
    style: {
      fill: "#fff"
    }
  }), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M57.39,115.48a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.59,121a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,45.59,121Z",
    style: {
      fill: "#fff"
    }
  }), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M45.33,120.89a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.43.43,0,0,0,.25.07.44.44,0,0,0,.26-.07.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.93,120.18a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,46.93,120.18Z",
    style: {
      fill: "#fff"
    }
  }), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M46.67,120.11a.52.52,0,0,0-.25.07.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.01,
    cy: 119.55,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M48,119.34a.51.51,0,0,0-.25.06c-.15.08-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.61,118.63c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.15-.09-.15-.22,0-.3A.57.57,0,0,1,49.61,118.63Z",
    style: {
      fill: "#fff"
    }
  }), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M49.35,118.57a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51,117.86a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.53.53,0,0,1,51,117.86Z",
    style: {
      fill: "#fff"
    }
  }), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M50.69,117.8a.58.58,0,0,0-.26.06.15.15,0,0,0,0,.29.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.29,117.08c.14.09.14.22,0,.3a.59.59,0,0,1-.52,0c-.14-.08-.14-.21,0-.3A.59.59,0,0,1,52.29,117.08Z",
    style: {
      fill: "#fff"
    }
  }), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M52,117a.55.55,0,0,0-.26.06c-.14.09-.14.22,0,.3a.59.59,0,0,0,.52,0c.14-.08.14-.21,0-.3A.55.55,0,0,0,52,117Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "53.13 116.37 53.02 116.07 53.23 116.51 53.23 116.53 53.13 116.37",
    style: {
      fill: "#fff"
    }
  }), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M53.37,116.25a.51.51,0,0,0-.25.06h0c-.14.08-.14.21,0,.3a.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.09.15-.22,0-.3a.51.51,0,0,0-.25-.06Zm-.22,0,0,0h0l0,0Zm0,0,0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.25,120.18a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,44.25,120.18Z",
    style: {
      fill: "#fff"
    }
  }), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M44,120.11a.53.53,0,0,0-.26.07.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.52.52,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.59,119.4a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,45.59,119.4Z",
    style: {
      fill: "#fff"
    }
  }), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M45.33,119.34a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.93,118.63c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,46.93,118.63Z",
    style: {
      fill: "#fff"
    }
  }), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M46.67,118.57a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.01,
    cy: 118,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M48,117.8a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.61,117.08c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.3A.57.57,0,0,1,49.61,117.08Z",
    style: {
      fill: "#fff"
    }
  }), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M49.35,117a.51.51,0,0,0-.25.06c-.15.09-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.91,119.4a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,42.91,119.4Z",
    style: {
      fill: "#fff"
    }
  }), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M42.66,119.34a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.25,118.63c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,44.25,118.63Z",
    style: {
      fill: "#fff"
    }
  }), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M44,118.57a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3A.53.53,0,0,0,44,119a.51.51,0,0,0,.25-.06c.14-.09.14-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.59,117.86a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,45.59,117.86Z",
    style: {
      fill: "#fff"
    }
  }), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M45.33,117.8a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.93,117.08c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,46.93,117.08Z",
    style: {
      fill: "#fff"
    }
  }), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M46.67,117a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.57,118.63c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,41.57,118.63Z",
    style: {
      fill: "#fff"
    }
  }), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M41.32,118.57a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.09.14-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.91,117.86a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,42.91,117.86Z",
    style: {
      fill: "#fff"
    }
  }), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M42.66,117.8a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.25,117.08c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,44.25,117.08Z",
    style: {
      fill: "#fff"
    }
  }), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M44,117a.53.53,0,0,0-.26.06c-.14.09-.14.22,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.08.14-.21,0-.3A.51.51,0,0,0,44,117Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.23,117.86c.15.08.15.21,0,.29a.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,40.23,117.86Z",
    style: {
      fill: "#fff"
    }
  }), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M40,117.8a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.29a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.57,117.08c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,41.57,117.08Z",
    style: {
      fill: "#fff"
    }
  }), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M41.32,117a.53.53,0,0,0-.26.06c-.14.09-.14.22,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.08.14-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.88,117.08a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,38.88,117.08Z",
    style: {
      fill: "#fff"
    }
  }), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M38.63,117a.44.44,0,0,0-.26.07.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.43.43,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.22,116.6a.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3C39.85,116.22,40.36,116.52,40.22,116.6Z",
    style: {
      fill: "#fff"
    }
  }), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M39.77,116.29h-.06a.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.13-.07-.26-.31-.45-.31Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.54,116.3c.15.08.15.22,0,.3a.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,37.54,116.3Z",
    style: {
      fill: "#fff"
    }
  }), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M37.29,116.24a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.07,130.89c.15.08.15.22,0,.3a.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,63.07,130.89Z",
    style: {
      fill: "#fff"
    }
  }), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M62.82,130.83a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.41,130.12a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,64.41,130.12Z",
    style: {
      fill: "#fff"
    }
  }), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M64.16,130.06a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.44.44,0,0,0,.26.07.43.43,0,0,0,.25-.07.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.75,129.35a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,65.75,129.35Z",
    style: {
      fill: "#fff"
    }
  }), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5,129.28a.53.53,0,0,0-.26.07.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.52.52,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.09,128.57a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,67.09,128.57Z",
    style: {
      fill: "#fff"
    }
  }), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M66.84,128.51a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.43,127.8c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,68.43,127.8Z",
    style: {
      fill: "#fff"
    }
  }), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M68.17,127.74a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.77,127a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,69.77,127Z",
    style: {
      fill: "#fff"
    }
  }), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M69.51,127a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.11,126.25c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,71.11,126.25Z",
    style: {
      fill: "#fff"
    }
  }), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M70.85,126.19a.51.51,0,0,0-.25.06c-.14.09-.14.22,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.45,125.48c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.15-.09-.15-.22,0-.3A.57.57,0,0,1,72.45,125.48Z",
    style: {
      fill: "#fff"
    }
  }), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M72.19,125.42a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.79,124.71a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.59.59,0,0,1,73.79,124.71Z",
    style: {
      fill: "#fff"
    }
  }), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M73.53,124.65a.58.58,0,0,0-.26.06.15.15,0,0,0,0,.29.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.13,123.93c.14.09.14.22,0,.3a.59.59,0,0,1-.52,0c-.14-.08-.14-.21,0-.3A.59.59,0,0,1,75.13,123.93Z",
    style: {
      fill: "#fff"
    }
  }), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M74.87,123.87a.55.55,0,0,0-.26.06c-.14.09-.14.22,0,.3a.59.59,0,0,0,.52,0c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.47,123.16a.16.16,0,0,1,0,.3.59.59,0,0,1-.52,0,.16.16,0,0,1,0-.3A.59.59,0,0,1,76.47,123.16Z",
    style: {
      fill: "#fff"
    }
  }), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M76.21,123.1a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06.16.16,0,0,0,0-.3.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.8,122.39c.15.08.15.21,0,.29a.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,77.8,122.39Z",
    style: {
      fill: "#fff"
    }
  }), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M77.55,122.33a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.29a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.47,
    cy: 130.26,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M61.47,130.05a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.81,
    cy: 129.49,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M62.81,129.28a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.4,128.56c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,64.4,128.56Z",
    style: {
      fill: "#fff"
    }
  }), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M64.15,128.5a.53.53,0,0,0-.26.06c-.14.09-.14.22,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.08.14-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.74,127.79a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,65.74,127.79Z",
    style: {
      fill: "#fff"
    }
  }), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M65.48,127.73a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,127a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,67.08,127Z",
    style: {
      fill: "#fff"
    }
  }), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M66.82,127a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.43.43,0,0,0,.25.07.44.44,0,0,0,.26-.07.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.42,126.25a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,68.42,126.25Z",
    style: {
      fill: "#fff"
    }
  }), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M68.16,126.18a.43.43,0,0,0-.25.07.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.44.44,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.76,125.47a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0c-.15-.08-.15-.22,0-.3A.57.57,0,0,1,69.76,125.47Z",
    style: {
      fill: "#fff"
    }
  }), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5,125.41a.51.51,0,0,0-.25.06c-.15.08-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.84,
    cy: 124.85,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M70.84,124.64a.58.58,0,0,0-.26.06.15.15,0,0,0,0,.29.48.48,0,0,0,.26.07.46.46,0,0,0,.26-.07.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.44,123.93a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.53.53,0,0,1,72.44,123.93Z",
    style: {
      fill: "#fff"
    }
  }), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M72.18,123.86a.56.56,0,0,0-.26.07.15.15,0,0,0,0,.29.59.59,0,0,0,.52,0,.15.15,0,0,0,0-.29.56.56,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.78,123.15a.16.16,0,0,1,0,.3.59.59,0,0,1-.52,0,.16.16,0,0,1,0-.3A.59.59,0,0,1,73.78,123.15Z",
    style: {
      fill: "#fff"
    }
  }), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M73.52,123.09a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06.16.16,0,0,0,0-.3.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.11,122.38c.15.08.15.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,75.11,122.38Z",
    style: {
      fill: "#fff"
    }
  }), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M74.86,122.32a.55.55,0,0,0-.26.06c-.14.08-.14.21,0,.3a.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.09.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.45,121.61a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,76.45,121.61Z",
    style: {
      fill: "#fff"
    }
  }), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2,121.55a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.79,120.83c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,77.79,120.83Z",
    style: {
      fill: "#fff"
    }
  }), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M77.54,120.77a.53.53,0,0,0-.26.06c-.14.09-.14.22,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.08.14-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.38,129.34c.15.08.15.21,0,.29a.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,60.38,129.34Z",
    style: {
      fill: "#fff"
    }
  }), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M60.13,129.28a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.29a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.47,
    cy: 128.71,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M61.47,128.5a.53.53,0,0,0-.26.06c-.14.09-.14.22,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.08.14-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.81,
    cy: 127.94,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M62.81,127.73a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.4,127a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,64.4,127Z",
    style: {
      fill: "#fff"
    }
  }), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M64.15,127a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.44.44,0,0,0,.26.07.43.43,0,0,0,.25-.07.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.74,126.25a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,65.74,126.25Z",
    style: {
      fill: "#fff"
    }
  }), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M65.48,126.18a.43.43,0,0,0-.25.07.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.44.44,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,125.47a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,67.08,125.47Z",
    style: {
      fill: "#fff"
    }
  }), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M66.82,125.41a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.42,124.7a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,68.42,124.7Z",
    style: {
      fill: "#fff"
    }
  }), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M68.16,124.64a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.43.43,0,0,0,.25.07.44.44,0,0,0,.26-.07.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.76,123.93a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.52.52,0,0,1,69.76,123.93Z",
    style: {
      fill: "#fff"
    }
  }), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5,123.86a.52.52,0,0,0-.25.07c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.56.56,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.1,123.15a.16.16,0,0,1,0,.3.59.59,0,0,1-.52,0,.16.16,0,0,1,0-.3A.59.59,0,0,1,71.1,123.15Z",
    style: {
      fill: "#fff"
    }
  }), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M70.84,123.09a.58.58,0,0,0-.26.06.16.16,0,0,0,0,.3.58.58,0,0,0,.26.06.55.55,0,0,0,.26-.06.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.44,122.38c.14.08.14.21,0,.3a.59.59,0,0,1-.52,0c-.14-.09-.14-.22,0-.3A.59.59,0,0,1,72.44,122.38Z",
    style: {
      fill: "#fff"
    }
  }), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M72.18,122.32a.55.55,0,0,0-.26.06c-.14.08-.14.21,0,.3a.59.59,0,0,0,.52,0c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.78,121.61a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.53.53,0,0,1,73.78,121.61Z",
    style: {
      fill: "#fff"
    }
  }), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M73.52,121.55a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06.15.15,0,0,0,0-.29.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.11,120.83c.15.09.15.22,0,.3a.57.57,0,0,1-.51,0c-.14-.08-.14-.21,0-.3A.57.57,0,0,1,75.11,120.83Z",
    style: {
      fill: "#fff"
    }
  }), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M74.86,120.77a.55.55,0,0,0-.26.06c-.14.09-.14.22,0,.3a.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.45,120.06c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,76.45,120.06Z",
    style: {
      fill: "#fff"
    }
  }), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2,120a.53.53,0,0,0-.26.06c-.14.08-.14.21,0,.3a.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.09.14-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.05,128.56c.14.09.14.22,0,.3a.59.59,0,0,1-.52,0c-.14-.08-.14-.21,0-.3A.59.59,0,0,1,59.05,128.56Z",
    style: {
      fill: "#fff"
    }
  }), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M58.79,128.5a.55.55,0,0,0-.26.06c-.14.09-.14.22,0,.3a.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.38,127.79c.15.08.15.22,0,.3a.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,60.38,127.79Z",
    style: {
      fill: "#fff"
    }
  }), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M60.13,127.73a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.22,0-.3a.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.47,
    cy: 127.17,
    rx: 0.36,
    ry: 0.21,
    style: {
      fill: "#fff"
    }
  }), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M61.47,127a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.44.44,0,0,0,.26.07.43.43,0,0,0,.25-.07.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.06,126.25a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,63.06,126.25Z",
    style: {
      fill: "#fff"
    }
  }), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M62.81,126.18a.44.44,0,0,0-.26.07.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.43.43,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.4,125.47a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,64.4,125.47Z",
    style: {
      fill: "#fff"
    }
  }), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M64.15,125.41a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.74,124.7a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,65.74,124.7Z",
    style: {
      fill: "#fff"
    }
  }), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M65.48,124.64a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.43.43,0,0,0,.25.07.44.44,0,0,0,.26-.07.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,123.93a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,67.08,123.93Z",
    style: {
      fill: "#fff"
    }
  }), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M66.82,123.86a.52.52,0,0,0-.25.07.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.42,123.15a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,68.42,123.15Z",
    style: {
      fill: "#fff"
    }
  }), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M68.16,123.09a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.76,122.38c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.15-.09-.15-.22,0-.3A.57.57,0,0,1,69.76,122.38Z",
    style: {
      fill: "#fff"
    }
  }), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5,122.32a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.1,121.61a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.29A.52.52,0,0,1,71.1,121.61Z",
    style: {
      fill: "#fff"
    }
  }), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M70.84,121.55a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.29a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.44,120.83c.14.09.14.22,0,.3a.59.59,0,0,1-.52,0c-.14-.08-.14-.21,0-.3A.59.59,0,0,1,72.44,120.83Z",
    style: {
      fill: "#fff"
    }
  }), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M72.18,120.77a.55.55,0,0,0-.26.06c-.14.09-.14.22,0,.3a.59.59,0,0,0,.52,0c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.78,120.06c.14.08.14.21,0,.3a.59.59,0,0,1-.52,0c-.14-.09-.14-.22,0-.3A.59.59,0,0,1,73.78,120.06Z",
    style: {
      fill: "#fff"
    }
  }), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M73.52,120a.55.55,0,0,0-.26.06c-.14.08-.14.21,0,.3a.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.11,119.29c.15.08.15.21,0,.29a.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29.57.57,0,0,1,.51,0Z",
    style: {
      fill: "#fff"
    }
  }), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M74.86,119.23a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.14-.08.15-.21,0-.29h0a.66.66,0,0,0-.25,0Zm.21,0,0,0h0l0,0Zm0,0h0l0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.71,127.79a.16.16,0,0,1,0,.3.59.59,0,0,1-.52,0,.16.16,0,0,1,0-.3A.59.59,0,0,1,57.71,127.79Z",
    style: {
      fill: "#fff"
    }
  }), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M57.45,127.73a.55.55,0,0,0-.26.06.16.16,0,0,0,0,.3.59.59,0,0,0,.52,0,.16.16,0,0,0,0-.3.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.05,127a.15.15,0,0,1,0,.29.53.53,0,0,1-.52,0,.15.15,0,0,1,0-.29A.59.59,0,0,1,59.05,127Z",
    style: {
      fill: "#fff"
    }
  }), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M58.79,127a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.46.46,0,0,0,.26.07.48.48,0,0,0,.26-.07.15.15,0,0,0,0-.29.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.38,126.25c.15.08.15.21,0,.29a.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,60.38,126.25Z",
    style: {
      fill: "#fff"
    }
  }), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M60.13,126.18a.46.46,0,0,0-.26.07.15.15,0,0,0,0,.29.55.55,0,0,0,.26.06.51.51,0,0,0,.25-.06c.15-.08.15-.21,0-.29a.43.43,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.72,125.47a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,61.72,125.47Z",
    style: {
      fill: "#fff"
    }
  }), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M61.47,125.41a.53.53,0,0,0-.26.06.16.16,0,0,0,0,.3.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.16.16,0,0,0,0-.3.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.06,124.7a.15.15,0,0,1,0,.29.52.52,0,0,1-.51,0,.15.15,0,0,1,0-.29A.57.57,0,0,1,63.06,124.7Z",
    style: {
      fill: "#fff"
    }
  }), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M62.81,124.64a.53.53,0,0,0-.26.06.15.15,0,0,0,0,.29.44.44,0,0,0,.26.07.43.43,0,0,0,.25-.07.15.15,0,0,0,0-.29.51.51,0,0,0-.25-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.4,123.93a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,64.4,123.93Z",
    style: {
      fill: "#fff"
    }
  }), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M64.15,123.86a.53.53,0,0,0-.26.07.15.15,0,0,0,0,.29.53.53,0,0,0,.26.06.51.51,0,0,0,.25-.06.15.15,0,0,0,0-.29.52.52,0,0,0-.25-.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.74,123.15a.16.16,0,0,1,0,.3.57.57,0,0,1-.51,0,.16.16,0,0,1,0-.3A.57.57,0,0,1,65.74,123.15Z",
    style: {
      fill: "#fff"
    }
  }), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M65.48,123.09a.51.51,0,0,0-.25.06.16.16,0,0,0,0,.3.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.16.16,0,0,0,0-.3.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,122.38c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.14-.09-.14-.22,0-.3A.57.57,0,0,1,67.08,122.38Z",
    style: {
      fill: "#fff"
    }
  }), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M66.82,122.32a.51.51,0,0,0-.25.06c-.14.08-.14.21,0,.3a.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.42,121.61a.15.15,0,0,1,0,.29.57.57,0,0,1-.51,0,.15.15,0,0,1,0-.29A.52.52,0,0,1,68.42,121.61Z",
    style: {
      fill: "#fff"
    }
  }), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M68.16,121.55a.51.51,0,0,0-.25.06.15.15,0,0,0,0,.29.51.51,0,0,0,.25.06.53.53,0,0,0,.26-.06.15.15,0,0,0,0-.29.53.53,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.76,120.83c.14.09.14.22,0,.3a.57.57,0,0,1-.51,0c-.15-.08-.15-.21,0-.3A.57.57,0,0,1,69.76,120.83Z",
    style: {
      fill: "#fff"
    }
  }), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5,120.77a.51.51,0,0,0-.25.06c-.15.09-.15.22,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.1,120.06c.14.08.14.21,0,.3a.57.57,0,0,1-.51,0c-.15-.09-.15-.22,0-.3A.57.57,0,0,1,71.1,120.06Z",
    style: {
      fill: "#fff"
    }
  }), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M70.84,120a.51.51,0,0,0-.25.06c-.15.08-.15.21,0,.3a.51.51,0,0,0,.25.06.55.55,0,0,0,.26-.06c.14-.09.14-.22,0-.3a.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.44,119.29a.15.15,0,0,1,0,.29.59.59,0,0,1-.52,0,.15.15,0,0,1,0-.29A.59.59,0,0,1,72.44,119.29Z",
    style: {
      fill: "#fff"
    }
  }), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M72.18,119.23a.55.55,0,0,0-.26.06.15.15,0,0,0,0,.29.59.59,0,0,0,.52,0,.15.15,0,0,0,0-.29.55.55,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.78,118.51c.14.09.14.22,0,.3a.59.59,0,0,1-.52,0c-.14-.08-.14-.21,0-.3A.59.59,0,0,1,73.78,118.51Z",
    style: {
      fill: "#fff"
    }
  }), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M73.52,118.45a.55.55,0,0,0-.26.06c-.14.09-.14.22,0,.3a.55.55,0,0,0,.26.06.58.58,0,0,0,.26-.06c.14-.08.14-.21,0-.3a.58.58,0,0,0-.26-.06Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "37.26 99.96 37.26 101.87 71.67 121.68 71.67 119.83 37.26 99.96",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.67 119.83 37.26 99.96 41.37 97.58 75.79 117.46 71.67 119.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.25,101.87V100l4.12-2.38,34.42,19.88v1.85l-4.11,2.38Zm0,0,34.41,19.81v-1.85L37.26,100Zm0-1.91,34.41,19.87,4.12-2.37L41.37,97.59Z",
    style: {
      fill: "#fff"
    }
  }), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M75.54,117.89v1.28l-3.62,2.08h0V120h0l2.63-1.51,1-.57h0M41.37,97.29l-4.11,2.38-.26.15V102l34.42,19.82.25.14.26-.14L76,119.46v-2.15l-.25-.14L41.5,97.37l-.13-.08Zm30.3,22.25-12.22-7.05L37.76,100l3.61-2.08,33.92,19.58-1,.57-2.63,1.51Zm-.25,1.71L37.51,101.72V100.4L71.42,120v1.27Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "31.64 102.97 31.64 104.88 66.05 124.7 66.05 122.85 31.64 102.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.05 122.85 31.64 102.97 35.75 100.6 70.17 120.47 66.05 122.85",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.63,104.88V103l4.12-2.37,34.42,19.87v1.86l-4.12,2.37Zm0,0,34.41,19.81v-1.84L31.64,103Zm0-1.9,34.41,19.86,4.12-2.37L35.75,100.6Z",
    style: {
      fill: "#fff"
    }
  }), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M69.92,120.9v1.28l-3.62,2.09h0V123h0l2.63-1.51,1-.58h0M35.75,100.31l-4.11,2.37-.26.15V105L65.8,124.84l.25.15.26-.15,4.11-2.37v-2.14l-.25-.15-34.29-19.8-.13-.07Zm30.3,22.25L53.83,115.5,32.14,103l3.61-2.09,33.92,19.58-1,.57-2.63,1.52Zm-.25,1.7L31.89,104.74v-1.33L65.8,123v1.27Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "26.02 106.22 26.02 108.13 60.43 127.95 60.43 126.1 26.02 106.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.43 126.1 26.02 106.22 30.13 103.85 64.55 123.72 60.43 126.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,108.13v-1.91l4.12-2.37,34.42,19.87v1.86L60.43,128Zm0,0,34.41,19.81V126.1L26,106.23Zm0-1.9,34.41,19.86,4.12-2.37L30.13,103.85Z",
    style: {
      fill: "#fff"
    }
  }), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3,124.15v1.28l-3.62,2.09h0v-1.27h0l2.63-1.51,1-.58h0M30.13,103.56,26,105.93l-.26.15v2.2l34.42,19.81.25.15.26-.15,4.11-2.37v-2.14l-.25-.15-34.29-19.8-.13-.07Zm30.3,22.25-12.22-7.06L26.52,106.23l3.61-2.09,33.92,19.58-1,.57-2.63,1.52Zm-.25,1.7L26.27,108v-1.33l33.91,19.58v1.27Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "20.4 109.48 20.4 111.39 54.81 131.21 54.81 129.36 20.4 109.48 20.4 109.48",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.81 129.36 20.4 109.48 24.51 107.11 58.93 126.98 54.81 129.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.39,111.39v-1.91l4.12-2.37L58.93,127v1.86l-4.12,2.37Zm0,0L54.81,131.2v-1.84L20.4,109.49Zm0-1.9,34.41,19.86L58.93,127,24.51,107.11Z",
    style: {
      fill: "#fff"
    }
  }), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M58.68,127.41v1.28l-3.62,2.09h0V129.5h0L57.69,128l1-.57h0M24.51,106.82l-4.11,2.37-.26.15v2.2l34.42,19.81.25.15.26-.15L59.18,129v-2.15l-.25-.14-34.29-19.8-.13-.07Zm30.3,22.25L42.59,122,20.9,109.48l3.61-2.08L58.43,127l-1,.57-2.63,1.52Zm-.25,1.7L20.65,111.25v-1.33L54.56,129.5v1.27Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "37.26 93.96 37.26 95.87 71.67 115.69 71.67 113.83 37.26 93.96",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.67 113.83 37.26 93.96 41.37 91.59 75.79 111.46 71.67 113.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.25,95.87V94l4.12-2.38,34.42,19.88v1.85l-4.12,2.38Zm0,0,34.41,19.81v-1.84L37.26,94Zm0-1.91,34.41,19.87,4.12-2.37L41.37,91.59Z",
    style: {
      fill: "#fff"
    }
  }), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M75.54,111.89v1.28l-3.62,2.09h0V114h0l2.63-1.52,1-.57h0M41.37,91.3l-4.11,2.37-.26.15V96l34.42,19.81.25.15.26-.15L76,113.46v-2.15l-.25-.14L41.5,91.37l-.13-.07Zm30.3,22.24-12.22-7.05L37.76,94l3.61-2.08,33.92,19.58-1,.57-2.63,1.51Zm-.25,1.71L37.51,95.72V94.4L71.42,114v1.27Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "31.64 96.98 31.64 98.88 66.05 118.7 66.05 116.85 31.64 96.98",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.05 116.85 31.64 96.98 35.75 94.6 70.17 114.47 66.05 116.85",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.63,98.89V97l4.12-2.38,34.42,19.87v1.86l-4.12,2.37Zm0,0L66.05,118.7v-1.85L31.64,97Zm0-1.9,34.41,19.87,4.12-2.38L35.75,94.6Z",
    style: {
      fill: "#fff"
    }
  }), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M69.92,114.9v1.28l-3.62,2.09h0V117h0l2.63-1.51,1-.57h0M35.75,94.31l-4.11,2.38-.26.14V99L65.8,118.84l.25.15.26-.15,4.11-2.37v-2.14l-.25-.15L35.88,94.38l-.13-.07Zm30.3,22.25L53.83,109.5,32.14,97l3.61-2.09,33.92,19.58-1,.57-2.63,1.52Zm-.25,1.7L31.89,98.74V97.41L65.8,117v1.27Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "26.02 100.23 26.02 102.14 60.43 121.95 60.43 120.1 26.02 100.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20.4 103.49 20.4 105.39 54.81 125.21 54.81 123.36 20.4 103.49",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.43 120.1 26.02 100.23 30.13 97.85 64.55 117.72 60.43 120.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,102.14v-1.91l4.12-2.38,34.42,19.87v1.86L60.43,122Zm0,0L60.43,122V120.1L26,100.23Zm0-1.9L60.43,120.1l4.12-2.38L30.13,97.85Z",
    style: {
      fill: "#fff"
    }
  }), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3,118.15v1.28l-3.62,2.09h0v-1.27h0l2.63-1.51,1-.57h0M30.13,97.56,26,99.94l-.26.14v2.2l34.42,19.81.25.15.26-.15,4.11-2.37v-2.14l-.25-.15L30.26,97.63l-.13-.07Zm30.3,22.25-12.22-7.06L26.52,100.23l3.61-2.09,33.92,19.58-1,.57-2.63,1.52Zm-.25,1.7L26.27,102v-1.33l33.91,19.58v1.27Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "54.81 123.36 20.4 103.49 24.51 101.11 58.93 120.98 54.81 123.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.39,105.4v-1.91l4.12-2.38L58.93,121v1.86l-4.12,2.37Zm0,0,34.41,19.82v-1.85L20.4,103.49Zm0-1.9,34.41,19.87L58.93,121,24.51,101.11Z",
    style: {
      fill: "#fff"
    }
  }), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M58.68,121.41v1.28l-3.62,2.09h0V123.5h0L57.69,122l1-.58h0M24.51,100.82,20.4,103.2l-.26.14v2.2l34.42,19.81.25.15.26-.15L59.18,123v-2.14l-.25-.15-34.29-19.8-.13-.07Zm30.3,22.25L42.59,116,20.9,103.49l3.61-2.09L58.43,121l-1,.57-2.63,1.52Zm-.25,1.7L20.65,105.25v-1.33L54.56,123.5v1.27Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "45.5 124.01 45.5 119.83 50.71 122.85 50.71 126.99 45.5 124.01",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5,124v-4.18l5.21,3v.29l3.1,1.78-3.1,1.78V127Zm0,0,5.21,3v-4.13l-5.21-3Z",
    style: {
      fill: "#fff"
    }
  }), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M51,123.57l2.35,1.35L51,126.27v-2.7m-5.71-4.17v4.76L51,127.42v-.58l3.35-1.92L51,123v-.29l-5.71-3.3Zm5.21,7.15-4.71-2.69v-3.59L50.46,123v3.56Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "24.05 111.57 24.05 107.5 29.26 110.54 29.26 114.6 24.05 111.57",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.05,111.57v-4.08l5.21,3.05v.21l3.1,1.78-3.1,1.78v.29Zm0,0,5.21,3v-4.06l-5.21-3Z",
    style: {
      fill: "#fff"
    }
  }), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M29.51,111.18l2.35,1.35-2.35,1.35v-2.7m-5.71-4.12v4.65L29.51,115v-.59l3.35-1.92-3.35-1.93v-.2l-5.71-3.34Zm5.21,7.1-4.71-2.74v-3.48L29,110.69v3.47Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "34.52 117.6 34.52 113.54 39.73 116.58 39.73 120.64 34.52 117.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.52,117.61v-4.08l5.21,3v.21l3.1,1.78-3.1,1.78v.29Zm0,0,5.21,3v-4l-5.21-3Z",
    style: {
      fill: "#fff"
    }
  }), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M40,117.22l2.35,1.35L40,119.92v-2.7m-5.71-4.12v4.65L40,121.08v-.59l3.35-1.92L40,116.64v-.2l-5.71-3.34Zm5.21,7.1-4.71-2.74V114l4.71,2.74v3.48Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "30.18 102.3 30.18 91.84 39.23 97.07 39.23 107.53 30.18 102.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.43 91.41 39.48 86.18 48.53 91.41 39.48 96.64 30.43 91.41",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.89,102.46V91.4l.17-.1,9.42-5.44,9.59,5.53v11.07L39.48,108Zm.07,0,9.49,5.48v-11L30,91.46Zm0-11,9.49,5.48L49,91.41l-9.49-5.48Z",
    style: {
      fill: "#111"
    }
  }), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M48.82,91.79v10.53l-9.12,5.26V97.05l0,0,4.48-2.58,4.51-2.61.1,0m-9.34-6.22-9.55,5.51-.29.18v11.35l9.56,5.51.28.16.28-.16,9.56-5.51V91.25l-9.84-5.68Zm0,11-1.41-.81-7.58-4.38,9-5.19,9,5.19L44,94,39.48,96.6Zm-.28,10.87-9-5.19V91.9l9,5.19v10.38Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "38.92 111.28 38.92 93.65 54.19 84.84 69.21 93.51 53.94 102.37 53.94 119.95 38.92 111.28",
    style: {
      fill: "#fff"
    }
  }), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M54.19,85.12l14.52,8.39-14.77,8.57-.25.14v17.3l-14.52-8.38V93.79l15-8.67m0-.57-15.52,9h0v17.92l15.52,8.95V102.51l15.52-9-15.52-9Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.61,111.46v-18l15.58-9,15.58,9v18l-15.58,9Zm.12-.07,15.4,8.89V102.5l-15.4-8.89Zm15.46-9,15.39-8.89L62,89.12l-7.79-4.5-15.4,8.89,7.6,4.39Z",
    style: {
      fill: "#111"
    }
  }), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M69.52,93.83v17.49l-15.14,8.74V102.57l.06,0,6.31-3.65,8.58-5,.19-.11M54.19,84.19,38.41,93.3l0,0h0v.35h0V111.6l15.52,9,.31.18.31-.18,15.36-8.87.16-.09V93.69h0v-.36L54.19,84.19ZM46.58,97.72l-7.29-4.21,14.9-8.6,7.29,4.21-14.9,8.6Zm7.61,4.39-7.3-4.21,14.9-8.6,7.29,4.21L60.5,98.46l-6.31,3.65Zm-.31,17.74L39,111.25V94l14.9,8.6v17.21Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.23,105.36a.77.77,0,0,1-.39-.12L45,103.58a2.26,2.26,0,0,1-.94-1.8.88.88,0,0,1,.34-.79.6.6,0,0,1,.27-.07A.79.79,0,0,1,45,101l2.88,1.66a2.26,2.26,0,0,1,.94,1.8.88.88,0,0,1-.34.79A.54.54,0,0,1,48.23,105.36Zm-3.81-4.26a.74.74,0,0,0-.28.68,2.09,2.09,0,0,0,.88,1.69l2.88,1.67a.76.76,0,0,0,.33.1h.07l.13,0a.7.7,0,0,0,.28-.61v-.15l-2.59-1.5a2.06,2.06,0,0,1-.85-1.48v-.13l-.31-.17a.65.65,0,0,0-.33-.11h-.07Z",
    style: {
      fill: "#fff"
    }
  }), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M45.57,101.65l2.2,1.27a1.91,1.91,0,0,1,.75,1.1l-2.26-1.31a1.68,1.68,0,0,1-.69-1.06m-.94-1a.77.77,0,0,0-.39.11,1.1,1.1,0,0,0-.47,1,2.49,2.49,0,0,0,1.06,2l2.88,1.66a1.06,1.06,0,0,0,.52.15.87.87,0,0,0,.39-.1,1.12,1.12,0,0,0,.47-1,2.48,2.48,0,0,0-1.07-2l-2.88-1.67a1,1,0,0,0-.51-.15Zm3.6,4.32a.48.48,0,0,1-.21-.07l-2.88-1.66a1.87,1.87,0,0,1-.75-1.48c0-.27.08-.42.16-.47l.08,0a.43.43,0,0,1,.2.07l.2.12a2.29,2.29,0,0,0,1,1.67l2.45,1.42c0,.23-.08.36-.15.4l-.08,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M48.48,33,.5,60.71l48,27.71,48-27.71Zm48,27.7-48,27.71v55.4l48-27.7Zm-48,27.71L.5,60.71v55.41l48,27.7Z",
    style: {
      fill: "none",
      stroke: "#111",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFgLight2);
export default __webpack_public_path__ + "static/media/ICON_fg_light_2.ef391f1848bb76f6b95717859ea1b95f.svg";
export { ForwardRef as ReactComponent };